export const adjustmentTypeOptions = [
  { id: "INCREASE", name: "Incremento" },
  { id: "DECREASE", name: "Disminución" },
];
